import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const SmallPlusIcon = (props: SvgProps) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
  >
    <path
      d="M1.5625 5H8.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 1.5625V8.4375"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
